import { useEffect, useRef } from "react";

export default function useUploadSuccessAlert(job, isComplete, platform) {
  const requested = useRef(new Set());
  const notified = useRef(new Set());

  useEffect(() => {
    const id = job?.request_id;
    if (!id || !requested.current.has(id) || notified.current.has(id) || !isComplete(job)) return;
    notified.current.add(id);
    window.alert(`${platform} 자동업로드 성공\n${job.store_name || "매장"} 게시가 완료되었습니다.`);
  }, [job, isComplete, platform]);

  return (id) => { if (id) requested.current.add(id); };
}
